const addFileToPickupCar = (state, item) => {
  state.filePickupCar.push(item);
};

const removeFileFromPickupCar = (state, index) => {
  state.filePickupCar.splice(index, 1)
};

const addBoxToPickupCar = (state, box) => {
  state.boxPickupCar.push(box);
};

const removeBoxFromPickupCar = (state, index) => {
  state.boxPickupCar.splice(index, 1);
}

const setPickupStorageMode = (state, mode) => {
  state.storageMode = mode;
};

const cleanPickupCar = (state, type) => {
  state.storageMode = null;
  if (type === 'BOX') {
    state.boxPickupCar = [];
  } else {
    state.filePickupCar = [];
  }
};

const setPickupList = (state, pickupList) => {
  state.pickupList = pickupList
}

export default {
  addFileToPickupCar,
  removeFileFromPickupCar,
  addBoxToPickupCar,
  removeBoxFromPickupCar,
  setPickupStorageMode,
  cleanPickupCar,
  setPickupList
};



// WEBPACK FOOTER //
// ./src/store/modules/pickup/mutations.js